// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, [96], () => (__webpack_require__("./src/modules/ui/theme-bootstrap.ts")))
let __webpack_exports__ = __webpack_require__.O(undefined, [96], () => (__webpack_require__("./src/index.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
